import React from "react";
import { useTranslation } from "react-i18next";

export default function ScaleSwitchModal({
  open = false,
  onConfirm = () => {},
  fromScaleVariant,
  toScaleVariant,
}) {
  const { i18n } = useTranslation();

  if (!open) return null;
  const isRedToGreenToGreenToRed =
    fromScaleVariant === "red_to_green" && toScaleVariant === "green_to_red";
  const scaleDirectionText = isRedToGreenToGreenToRed
    ? i18n.t("scaleSwitchModalDirectionBestToWorst")
    : i18n.t("scaleSwitchModalDirectionWorstToBest");

  return (
    <div
      className="ScreenOverlay"
      style={{ backgroundColor: "rgba(87, 122, 146, 0.45)" }}
    >
      <div
        className="ScreenContent"
        style={{
          maxWidth: "760px",
          borderRadius: "30px",
          padding: "48px 40px 36px",
          backgroundColor: "rgba(234, 245, 251, 1)",
            overflowY: "hidden",

        }}
      >
        <h2
          style={{
            margin: 0,
            marginBottom: "20px",
            textAlign: "center",
            color: "#1F1F1F",
            fontSize: "32px",
            lineHeight: '38px',
          }}
        >
          {i18n.t("scaleSwitchModalTitle")}
        </h2>

        <p
          style={{
            margin: 0,
            marginBottom: "30px",
            textAlign: "center",
            color: "#1F1F1F",
            fontSize: "18px",
            lineHeight: '24px',
          }}
        >
            {scaleDirectionText}
        </p>

        <div style={{ display: "flex", justifyContent: "center", width:'100%' }}>
          <button
            style={{
              border: "none",
              outline: "none",
              color: "white",
              minWidth: "240px",
              padding: "10px 24px",
              borderRadius: "23px",
              boxShadow: "0px 2px 4px rgba(217, 217, 217, 1)",
              backgroundColor: "rgba(97, 132, 157, 1)",
              cursor: "pointer",
              fontSize: "14px",
              lineHeight: 1.2,
            }}
            onClick={onConfirm}
          >
            {i18n.t("scaleSwitchModalConfirm")}
          </button>
        </div>
      </div>
    </div>
  );
}
